export const PAYMENTS_PATH = "/payments";
